import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "statistics-public__separator" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "statistics-public__caption" }
const _hoisted_4 = { class: "statistics-public__number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_digit_counter = _resolveComponent("digit-counter")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["statistics-public__title", { 'statistics-public__title--mobile': _ctx.isMobile }])
    }, _toDisplayString(_ctx.statisticTitle), 3),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (user) => {
        return (_openBlock(), _createElementBlock("div", {
          key: user.id,
          class: "col-xs-12 col-sm-6 col-md-4 s-mb-xl"
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(user.name), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_digit_counter, {
              count: user.count,
              "is-ssr": _ctx.isSsr
            }, null, 8, ["count", "is-ssr"])
          ])
        ]))
      }), 128))
    ])
  ], 512)), [
    [_vShow, _ctx.userList.length !== 0]
  ])
}